import React, { createContext, useContext, ReactNode, useMemo } from 'react';
import { useSetupStatusQuery } from '../api/JsdhNotifikaceService/service/SetupMutation';

interface SetupContextType {
    setupRequired: boolean;
    isLoading: boolean;
    error: Error | null;
    refetch: () => void;
}

const SetupContext = createContext<SetupContextType | undefined>(undefined);

export const SetupProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { data, isLoading, error, refetch } = useSetupStatusQuery();

    const value = useMemo<SetupContextType>(() => ({
        setupRequired: data?.setupRequired ?? false,
        isLoading,
        error: error ?? null,
        refetch,
    }), [data, isLoading, error, refetch]);

    return (
        <SetupContext.Provider value={value}>
            {children}
        </SetupContext.Provider>
    );
};

export const useSetup = (): SetupContextType => {
    const context = useContext(SetupContext);
    if (context === undefined) {
        throw new Error('useSetup must be used within a SetupProvider');
    }
    return context;
};

export default SetupContext;
